<script setup lang="ts">
import {onMounted, ref} from "vue";
import CustomButton from "@/components/Button/Button.vue";
import ArticleCard from "@/components/ArticleCard/ArticleCard.vue";
import { useRouter } from 'vue-router';
import { useBlogStore } from "@/stores/blogStore";
import {VueSpinner} from "vue3-spinners";
import {useArticleStore} from "@/stores/articleStore";

const blogStore = useBlogStore();
const articleStore = useArticleStore();

const router = useRouter();

const slug = "travel-inspiration";

onMounted(() => {
  blogStore.getAllArticles(slug, blogStore.currentPage, blogStore.articlesPerPage);
});

</script>

<template>
  <div class="bg-white mt-24 place-content-center place-items-center">
    <div class="container flex flex-col gap-17 place-content-center items-center py-24 overflow-x-hidden">
      <div class="responsive-title-1 text-primary-darkBlue font-thin text-center whitespace-nowrap">Featured Articles</div>
      <div v-if="blogStore.loading" class="grid place-content-center mt-10">
        <VueSpinner size="30" color="#beA5aa" />
      </div>
      <div v-else class="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 px-1">
        <div v-for="(page, index) in blogStore.allArticles.slice(0, 3)" :key="index">
          <ArticleCard
              :page="page"
              @on-visit-article="articleStore.visitArticle(page.slug)"
          />
        </div>
      </div>
      <CustomButton v-if="!blogStore.loading"
          type="gradient"
          :outlined="true"
          size="medium"
          :shadow="false"
          class="py-2 px-4"
          @click="router.push('/magazine')"
      >
        READ MORE ARTICLES
      </CustomButton>
    </div>
  </div>
</template>

<style scoped>

</style>
